export default __webpack_public_path__ + "static/media/setting.a32e85c4.svg";